<template>
  <div :draggable="true" :style="{ position: 'absolute' }">
    <slot></slot>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import {OVERLAY_VIEW} from '@/common/Constant'

export default {
  /*global google*/
  name: 'CustomOverlayView',
  mixins: [
    VueGoogleMaps.MapElementMixin
  ],
  props: {
    position: {
      type: Object,
      default: undefined
    },
    size: {
      type: Object,
      default: undefined
    },
    initBounds: {
      type: Object,
      default: undefined
    },
  },
  data() {
    return {
      bounds: null,
      listening: null,
    }
  },
  methods: {
    initBoundsData() {
      let sw, ne;
      if (this.initBounds) {
        sw = new google.maps.LatLng(this.initBounds.sw.lat, this.initBounds.sw.lng)
        ne = new google.maps.LatLng(this.initBounds.ne.lat, this.initBounds.ne.lng)
      } else {
        let ratio = {x: 0.00001, y: 0.00001}
        sw = new google.maps.LatLng(
          this.position.lat - ratio.y * this.size.height,
          this.position.lng - ratio.x * this.size.width
        )
        ne = new google.maps.LatLng(
          this.position.lat + ratio.y * this.size.height,
          this.position.lng + ratio.x * this.size.width
        )
      }
      this.setBoundsData(sw, ne)
    },
    setBoundsData(sw, ne) {
      this.bounds = new google.maps.LatLngBounds(sw, ne)
    },
    getOverlayData() {
      return {
        bounds: {
          sw: {
            lat: this.bounds.getSouthWest().lat(),
            lng: this.bounds.getSouthWest().lng()
          },
          ne: {
            lat: this.bounds.getNorthEast().lat(),
            lng: this.bounds.getNorthEast().lng()
          }
        },
        position: this.position,
        zoom: this.$overlay.getMap().getZoom(),
      }
    }
  },
  watch: {
    size() {
      this.initBoundsData()
      this.$overlay.draw()
    },
  },
  provide() {
    const self = this
    this.$mapPromise.then(map => {
      // CustomOverlayView
      class CustomOverlayView extends google.maps.OverlayView {
        constructor() {
          super()
          // A___________B
          // |           |
          // |  <image>  |
          // |___________|
          // D           C
          this.fixed = {a: undefined, b: undefined, c: undefined, d: undefined}
          this.move = {a: undefined, b: undefined, c: undefined, d: undefined}
          this.container = self.$el
          self.initBoundsData();
        }

        draw() {
          const projection = this.getProjection()
          const container = self.$el
          if (container) {
            const sw = projection.fromLatLngToDivPixel(self.bounds.getSouthWest())
            const ne = projection.fromLatLngToDivPixel(self.bounds.getNorthEast())

            //    ___________ ne
            //   |           |
            //   |           |
            //   |___________|
            // sw

            container.style.left = sw.x + "px";
            container.style.top = ne.y + "px";
            container.style.width = ne.x - sw.x + "px";
            container.style.height = sw.y - ne.y + "px";
          }
        }

        onAdd() {
          const panes = this.getPanes()
          panes.floatPane.appendChild(this.container)

          google.maps.event.addDomListener(
            self.$map.getDiv(),
            'mouseleave',
            () => {
              google.maps.event.trigger(this.container, 'mouseup')
              for (let child of this.container.children)
                google.maps.event.trigger(child, 'mouseup')
            }
          )

          if (this.container) {
            // draggable
            this.addDragEvent(this.container)
            // resize
            this.addResizeableEvent(this.container)
          }
        }

        addDragEvent(container) {
          let image = container.children[0]

          const projection = this.getProjection()
          let lastMouseMove = undefined

          if (image && image.id === 'imageOverlay' && image.tagName.toLowerCase() === 'img') {
            google.maps.event.addDomListener(image,
              'mousedown', (mouseDown) => {
                if (!self.listening) self.listening = OVERLAY_VIEW.MODE_DRAG
                else return
                self.$map.set('draggable', false)
                container.style.cursor = 'grabbing'
                lastMouseMove = mouseDown

                const mouseMoveHandler = google.maps.event.addDomListener(self.$map.getDiv(),
                  'mousemove', (mouseMove) => {
                    if (self.listening !== OVERLAY_VIEW.MODE_DRAG) return
                    let transitionX = lastMouseMove.clientX - mouseMove.clientX
                    let transitionY = lastMouseMove.clientY - mouseMove.clientY

                    let sw = self.bounds.getSouthWest()
                    let ne = self.bounds.getNorthEast()
                    let swPixel = projection.fromLatLngToDivPixel(sw)

                    let swNew = projection.fromDivPixelToLatLng(
                      new google.maps.Point(swPixel.x - transitionX, swPixel.y - transitionY)
                    )

                    let neNew = new google.maps.LatLng(
                      ne.lat() + swNew.lat() - sw.lat(),
                      ne.lng() + swNew.lng() - sw.lng()
                    )

                    self.setBoundsData(swNew, neNew)
                    this.draw()

                    lastMouseMove = mouseMove
                  }
                )

                const mouseUpHandler = google.maps.event.addDomListener(image,
                  'mouseup', () => {
                    if (self.listening !== OVERLAY_VIEW.MODE_DRAG) return
                    self.listening = null
                    self.$map.set('draggable', true)
                    container.style.cursor = 'grab'
                    google.maps.event.removeListener(mouseMoveHandler)
                    google.maps.event.removeListener(mouseUpHandler)
                  }
                )
              }
            )
          }
        }

        addResizeableEvent(container) {
          let resizeA = container.children[1]
          let resizeB = container.children[2]
          let resizeC = container.children[3]
          let resizeD = container.children[4]

          // A___________B
          // |           |
          // |           |
          // |___________|
          // D           C

          google.maps.event.addDomListener(resizeA, 'mousedown', (mouseDown) => this.resizeMouseDown(container, mouseDown, resizeA))
          google.maps.event.addDomListener(resizeB, 'mousedown', (mouseDown) => this.resizeMouseDown(container, mouseDown, resizeB))
          google.maps.event.addDomListener(resizeC, 'mousedown', (mouseDown) => this.resizeMouseDown(container, mouseDown, resizeC))
          google.maps.event.addDomListener(resizeD, 'mousedown', (mouseDown) => this.resizeMouseDown(container, mouseDown, resizeD))
        }

        resizeMouseDown(container, mouseDown, button) {
          if (!self.listening) self.listening = OVERLAY_VIEW.MODE_RESIZE
          else return
          self.$map.set('draggable', false)
          const projection = this.getProjection()
          let sw = self.bounds.getSouthWest();
          let ne = self.bounds.getNorthEast();
          this.fixed.b = projection.fromLatLngToDivPixel(ne) //NorthEast Pixel
          this.fixed.d = projection.fromLatLngToDivPixel(sw) //SouthWest Pixel
          this.fixed.a = new google.maps.Point(this.fixed.d.x, this.fixed.b.y)
          this.fixed.c = new google.maps.Point(this.fixed.b.x, this.fixed.d.y)
          this.move = {a: this.fixed.a, b: this.fixed.b, c: this.fixed.c, d: this.fixed.d}

          this.mouseMoveResizeHandler = google.maps.event.addDomListener(self.$map.getDiv(),
            'mousemove', (mouseMove) => this.resizeMouseMove(mouseMove, mouseDown, button)
          )

          this.mouseUpResizeHandler = google.maps.event.addDomListener(self.$map.getDiv(),
            'mouseup', () => this.resizeMouseUp())
        }

        resizeMouseMove(mouseMove, mouseDown, button) {
          if (self.listening !== OVERLAY_VIEW.MODE_RESIZE) return
          let tx = mouseMove.clientX - mouseDown.clientX;
          let ty = mouseMove.clientY - mouseDown.clientY;
          // A___________B
          // |           |
          // |  <image>  |
          // |___________|
          // D           C
          switch (button.id) {
            case 'resizeA':
              this.move.a = new google.maps.Point(this.fixed.a.x + tx, this.fixed.a.y + ty)
              this.container.style.left = this.move.a.x + "px";
              this.container.style.top = this.move.a.y + "px";
              break;
            case 'resizeB':
              this.move.b = new google.maps.Point(this.fixed.b.x + tx, this.fixed.b.y + ty)
              this.move.a = new google.maps.Point(this.fixed.a.x, this.move.b.y)
              this.move.c = new google.maps.Point(this.move.b.x, this.fixed.c.y)

              this.container.style.left = this.move.a.x + "px";
              this.container.style.top = this.move.a.y + "px";
              break;
            case 'resizeC':
              this.move.c = new google.maps.Point(this.fixed.c.x + tx, this.fixed.c.y + ty)
              break;
            case 'resizeD':
              this.move.d = new google.maps.Point(this.fixed.d.x + tx, this.fixed.d.y + ty)
              this.move.a = new google.maps.Point(this.move.d.x, this.fixed.a.y)
              this.move.c = new google.maps.Point(this.fixed.c.x, this.move.d.y)

              this.container.style.left = this.move.a.x + "px";
              this.container.style.top = this.move.a.y + "px";
              break;
            default:
          }
          this.container.style.width = this.move.c.x - this.move.a.x + "px";
          this.container.style.height = this.move.c.y - this.move.a.y + "px";

        }

        resizeMouseUp() {
          const projection = this.getProjection()
          if (self.listening !== OVERLAY_VIEW.MODE_RESIZE) return
          self.listening = null
          self.$map.set('draggable', true)
          google.maps.event.removeListener(this.mouseMoveResizeHandler)
          google.maps.event.removeListener(this.mouseUpResizeHandler)

          this.move.b = new google.maps.Point(this.move.c.x, this.move.a.y)
          this.move.d = new google.maps.Point(this.move.a.x, this.move.c.y)

          let neNew = projection.fromDivPixelToLatLng(this.move.b)
          let swNew = projection.fromDivPixelToLatLng(this.move.d)
          this.fixed = {a: undefined, b: undefined, c: undefined, d: undefined}
          this.move = {a: undefined, b: undefined, c: undefined, d: undefined}
          self.setBoundsData(swNew, neNew)
          this.draw()
        }

        onRemove() {
          self.$el.remove()
        }
      }

      this.$overlay = new CustomOverlayView()
      this.$overlay.setMap(map)
    })
  },
  destroyed() {
    this.$overlay.setMap(null)
    this.$overlay = undefined
  }
}
</script>

<style scoped>

</style>
